import { REGEX } from '@shared/constants/regex';

/** Save a Blob the browser received (exports, PDFs) under the server-provided name. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** `attachment; filename="X.csv"` → `X.csv` (falls back to `fallback`). */
export function fileNameFrom(contentDisposition: string | null, fallback: string): string {
  const match = REGEX.contentDispositionFileName.exec(contentDisposition ?? '');
  return match?.[1] ?? fallback;
}

export interface DownloadedFile {
  blob: Blob;
  fileName: string;
}
